import { render, staticRenderFns } from "./BtnGroupToggle.vue?vue&type=template&id=8b2ad400&"
import script from "./BtnGroupToggle.vue?vue&type=script&lang=js&"
export * from "./BtnGroupToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports